export default __webpack_public_path__ + "static/media/gp.3b415faf.svg";